<template>
    <modal ref="alertmodal"
           name="alertmodal"
           :pivotY="0.3"
           :reset="true"
           height="auto"
           width="50%"
           @before-open="beforeOpen"
           @closed="onClosed">
        <div class="modal-block" :class="params.type">
            <div class="modal-content-header" v-if="title">{{title}}</div>
            <div class="modal-content">
                <div class="message">
                    {{params.message}}
                </div>
                <div class="details-block" v-if="params.details">
                    <div class="details-button right-align">
                        <a @click="toggleDetails">
                            Details
                            <i class="fa" :class="{'fa-chevron-up': isDetailsOpen, 'fa-chevron-down': !isDetailsOpen}"></i>
                        </a>
                    </div>
                    <div class="details" v-if="isDetailsOpen">
                        {{params.details}}
                    </div>
                </div>
                <div class="buttons-block center-align">
                    <button class="a3d btn" @click="modalClose">{{params.dismissTitle}}</button>
                    <button class="a3d btn inv" @click="retry" v-if="params.isCanRetry">{{params.retryTitle}}</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
  export default {
    name: 'Alert',
    data () {
      return {
        isDetailsOpen: false,
        fireCallback: false,
        params: {
          type: null,
          title: null,
          isCanRetry: false
        }
      }
    },
    computed: {
      title () {
        if (this.params.title) {
          return this.params.title
        } else {
          if (this.params.type === 'danger') {
            return 'Error'
          } else if (this.params.type === 'info') {
            return 'information'
          } else {
            return null
          }
        }
      }
    },
    methods: {
      beforeOpen (event) {
        this.params = event.params
        this.fireCallback = false
      },
      toggleDetails () {
        this.isDetailsOpen = !this.isDetailsOpen
      },
      modalClose () {
        this.$modal.hide('alertmodal')
      },
      retry () {
        this.fireCallback = true
        this.$modal.hide('alertmodal')
      },
      onClosed () {
        if (this.fireCallback) {
          this.params.retryCallback()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
 .modal-block {
     &.danger {
         .modal-content-header {
             background-color: #fccccc;
         }
     }

     .modal-content-header {
         font-weight: bold;
     }

     .modal-content-header, .modal-content {
         padding: 12px;
     }

     .modal-content {
         .buttons-block {
             padding-top: 12px;
         }
         .details-block {
             .details-button {
                 a {
                     cursor: pointer;
                 }
             }

             .details {
                 padding: 4px 8px;
                 background-color: $bg-gray;
                 border: 1px solid $border-color;
                 word-break: break-all;
                 max-height: 400px;
                 overflow: auto;
             }
         }

     }
 }
</style>



// WEBPACK FOOTER //
// Alert.vue?d5a3bd1e